import { supabase } from '../supabaseClient';

export const formationService = {
  async getSettings(editionYear) {
    try {
      const { data: edition } = await supabase
        .from('editions')
        .select('id, year')
        .eq('year', editionYear)
        .single();

      if (!edition) throw new Error(`Edition ${editionYear} not found`);

      const { data: settings, error } = await supabase
        .from('formation_data')
        .select('*')
        .eq('edition_id', edition.id)
        .single();

      if (error && error.code !== 'PGRST116') throw error;

      return settings || {
        title: 'NOS FORMATIONS',
        subtitle: 'Améliorez vos compétences avec nos sessions expertes',
        is_visible: true,
        edition_id: edition.id
      };
    } catch (error) {
      console.error('Error getting formation settings:', error);
      throw error;
    }
  },

  async updateSettings(settings) {
    try {
      const { id, created_at, updated_at, ...updateData } = settings;
      
      if (id) {
        const { error } = await supabase
          .from('formation_data')
          .update({ ...updateData, updated_at: new Date().toISOString() })
          .eq('id', id);
        if (error) throw error;
      } else {
        const { error } = await supabase
          .from('formation_data')
          .insert([updateData]);
        if (error) throw error;
      }
    } catch (error) {
      console.error('Error updating formation settings:', error);
      throw error;
    }
  },

  async getFormations(editionYear) {
    try {
      const { data: edition } = await supabase
        .from('editions')
        .select('id')
        .eq('year', editionYear)
        .single();

      if (!edition) throw new Error(`Edition ${editionYear} not found`);

      const { data, error } = await supabase
        .from('formations')
        .select('*')
        .eq('edition_id', edition.id)
        .order('display_order', { ascending: true });

      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Error getting formations:', error);
      throw error;
    }
  },

  async saveFormation(formation) {
    try {
      const { id, created_at, updated_at, ...data } = formation;
      if (id) {
        const { error } = await supabase
          .from('formations')
          .update({ ...data, updated_at: new Date().toISOString() })
          .eq('id', id);
        if (error) throw error;
      } else {
        const { error } = await supabase
          .from('formations')
          .insert([data]);
        if (error) throw error;
      }
    } catch (error) {
      console.error('Error saving formation:', error);
      throw error;
    }
  },

  async deleteFormation(id) {
    try {
      const { error } = await supabase
        .from('formations')
        .delete()
        .eq('id', id);
      if (error) throw error;
    } catch (error) {
      console.error('Error deleting formation:', error);
      throw error;
    }
  },

  async register(registration) {
    try {
      const { error } = await supabase
        .from('formation_registrations')
        .insert([registration]);
      if (error) throw error;
    } catch (error) {
      console.error('Error registering for formation:', error);
      throw error;
    }
  },

  async getRegistrations(editionYear) {
    try {
      const { data: edition } = await supabase
        .from('editions')
        .select('id')
        .eq('year', editionYear)
        .single();

      if (!edition) throw new Error(`Edition ${editionYear} not found`);

      const { data, error } = await supabase
        .from('formation_registrations')
        .select('*, formations(title)')
        .eq('edition_id', edition.id)
        .order('created_at', { ascending: false });

      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Error getting formation registrations:', error);
      throw error;
    }
  },

  async deleteRegistration(id) {
    try {
      const { error } = await supabase
        .from('formation_registrations')
        .delete()
        .eq('id', id);
      if (error) throw error;
    } catch (error) {
      console.error('Error deleting registration:', error);
      throw error;
    }
  },

  async uploadFormationImage(file, editionYear) {
    try {
      const timestamp = Date.now();
      const fileExt = file.name.split('.').pop();
      const fileName = `formation-${timestamp}.${fileExt}`;
      const filePath = `${editionYear}/formations/${fileName}`;

      const { data, error } = await supabase.storage
        .from('speaker-images') // Reusing the same bucket for images if appropriate, or could use another
        .upload(filePath, file, {
          cacheControl: '3600',
          upsert: false
        });

      if (error) throw error;

      const { data: { publicUrl } } = supabase.storage
        .from('speaker-images')
        .getPublicUrl(filePath);

      return {
        path: filePath,
        url: publicUrl
      };
    } catch (error) {
      console.error('Error uploading formation image:', error);
      throw error;
    }
  },

  async deleteFormationFile(filePath) {
    try {
      if (!filePath) return;
      const { error } = await supabase.storage
        .from('speaker-images')
        .remove([filePath]);
      if (error) throw error;
    } catch (error) {
      console.error('Error deleting formation file:', error);
      throw error;
    }
  }
};
